import actions from "./actions";

const initState = {
  reservationHistory: [],
  loading: false,
};

export default function reservationHistoryReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_RESERVATIONS_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.GET_RESERVATIONS_HISTORY_SUCCESS:
      return {
        ...state,
        reservationHistory: action.reservationHistory,
        loading: false,
      };

    default:
      return state;
  }
}
